import { INSTAGRAM_CONTENT_TYPES, SOCIAL_PLATFORMS } from '~/constants';
import { CONTENT_SEARCH_PARAMS } from '~/hooks/useContentSearch';

import {
  ContentSearchDisabledComponentType,
  ContentSearchEnabledComponentType,
  ContentSearchOrderComponentType,
  ContentSearchPlatformChannelType,
  ContentSearchTrackIdComponentType,
} from './ContentSearchFilter.types';
import {
  ContentSearchFilterCreator,
  ContentSearchFilterFuzzyKeywordSearchToggle,
  ContentSearchFilterMyTalent,
  ContentSearchFilterPaidContentToggle,
  ContentSearchFilterPlatform,
  ContentSearchFilterPostedAtTimeframe,
  ContentSearchFilterSearch,
  ContentSearchFilterSort,
  ContentSearchFilterView,
} from './components';

export const CONTENT_SEARCH_PLATFORM_CHANNEL: ContentSearchPlatformChannelType =
  {
    [SOCIAL_PLATFORMS.instagram]: [
      {
        friendlyValue: 'Instagram Reels',
        value: INSTAGRAM_CONTENT_TYPES.reels,
      },
      {
        friendlyValue: 'Instagram Stills',
        value: INSTAGRAM_CONTENT_TYPES.post,
      },
      {
        friendlyValue: 'Instagram Stories',
        value: INSTAGRAM_CONTENT_TYPES.story,
      },
    ],
  };

export const CONTENT_SEARCH_IG_CHANNELS = [
  INSTAGRAM_CONTENT_TYPES.reels,
  INSTAGRAM_CONTENT_TYPES.post,
  INSTAGRAM_CONTENT_TYPES.story,
];

export const CONTENT_SEARCH_COMPONENTS = {
  [CONTENT_SEARCH_PARAMS.ads]: ContentSearchFilterPaidContentToggle,
  [CONTENT_SEARCH_PARAMS.creator]: ContentSearchFilterCreator,
  [CONTENT_SEARCH_PARAMS.platform]: ContentSearchFilterPlatform,
  [CONTENT_SEARCH_PARAMS.query]: ContentSearchFilterSearch,
  [CONTENT_SEARCH_PARAMS.roster]: ContentSearchFilterMyTalent,
  [CONTENT_SEARCH_PARAMS.sortBy]: ContentSearchFilterSort,
  [CONTENT_SEARCH_PARAMS.view]: ContentSearchFilterView,
  [CONTENT_SEARCH_PARAMS.fuzzy]: ContentSearchFilterFuzzyKeywordSearchToggle,
  [CONTENT_SEARCH_PARAMS.autoCompleteQuery]: ContentSearchFilterSearch,
  [CONTENT_SEARCH_PARAMS.postedAfter]: ContentSearchFilterPostedAtTimeframe,
} as const;

export const CONTENT_SEARCH_DEFAULT_ENABLED_COMPONENTS: Required<ContentSearchEnabledComponentType> =
  {
    [CONTENT_SEARCH_PARAMS.ads]: true,
    [CONTENT_SEARCH_PARAMS.creator]: false,
    [CONTENT_SEARCH_PARAMS.platform]: true,
    [CONTENT_SEARCH_PARAMS.query]: true,
    [CONTENT_SEARCH_PARAMS.roster]: false,
    [CONTENT_SEARCH_PARAMS.sortBy]: true,
    [CONTENT_SEARCH_PARAMS.view]: false,
    [CONTENT_SEARCH_PARAMS.fuzzy]: false,
    [CONTENT_SEARCH_PARAMS.autoCompleteQuery]: false,
    [CONTENT_SEARCH_PARAMS.postedAfter]: false,
  } as const;

export const CONTENT_SEARCH_DEFAULT_ORDER_COMPONENTS: Required<ContentSearchOrderComponentType> =
  {
    [CONTENT_SEARCH_PARAMS.ads]: 0,
    [CONTENT_SEARCH_PARAMS.creator]: 0,
    [CONTENT_SEARCH_PARAMS.platform]: 0,
    [CONTENT_SEARCH_PARAMS.query]: 0,
    [CONTENT_SEARCH_PARAMS.roster]: 0,
    [CONTENT_SEARCH_PARAMS.sortBy]: 0,
    [CONTENT_SEARCH_PARAMS.view]: 0,
    [CONTENT_SEARCH_PARAMS.fuzzy]: 0,
    [CONTENT_SEARCH_PARAMS.autoCompleteQuery]: 0,
    [CONTENT_SEARCH_PARAMS.postedAfter]: 0,
  } as const;

export const CONTENT_SEARCH_DEFAULT_TRACK_ID: Required<ContentSearchTrackIdComponentType> =
  {
    [CONTENT_SEARCH_PARAMS.ads]: 'filterbar-adToggle',
    [CONTENT_SEARCH_PARAMS.creator]: 'filterbar-find-creator-modal',
    [CONTENT_SEARCH_PARAMS.platform]: 'filterbar-platform',
    [CONTENT_SEARCH_PARAMS.query]: 'filterbar-query',
    [CONTENT_SEARCH_PARAMS.roster]: 'filterbar-toggle',
    [CONTENT_SEARCH_PARAMS.sortBy]: 'filterbar-sort',
    [CONTENT_SEARCH_PARAMS.view]: 'filterbar-view',
    [CONTENT_SEARCH_PARAMS.fuzzy]: 'filterbar-fuzzyToggle',
    [CONTENT_SEARCH_PARAMS.autoCompleteQuery]: 'filterbar-query-autocomplete',
    [CONTENT_SEARCH_PARAMS.postedAfter]: 'filterbar-posted-at',
  } as const;

export const CONTENT_SEARCH_DISABLED_COMPONENTS: Required<ContentSearchDisabledComponentType> =
  {
    [CONTENT_SEARCH_PARAMS.ads]: true,
    [CONTENT_SEARCH_PARAMS.creator]: true,
    [CONTENT_SEARCH_PARAMS.platform]: true,
    [CONTENT_SEARCH_PARAMS.query]: true,
    [CONTENT_SEARCH_PARAMS.roster]: false,
    [CONTENT_SEARCH_PARAMS.sortBy]: true,
    [CONTENT_SEARCH_PARAMS.view]: true,
    [CONTENT_SEARCH_PARAMS.fuzzy]: true,
    [CONTENT_SEARCH_PARAMS.autoCompleteQuery]: true,
    [CONTENT_SEARCH_PARAMS.postedAfter]: true,
  } as const;
